import { render } from "./ModalTermsAndConditions.vue?vue&type=template&id=662ca03a"
import script from "./ModalTermsAndConditions.vue?vue&type=script&lang=js"
export * from "./ModalTermsAndConditions.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mac/Projects/webshop/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__